import * as angular from 'angular';

class SecondaryPricingSectionComponentCtrl implements ng.IController {
    proposal: ProposalDto;
    price: any;
    noTitle: boolean;

    $onInit() {}
}

angular.module('app').component('pkpSecondaryPricingSection', {
    controller: SecondaryPricingSectionComponentCtrl,
    template:
        require('app/secondary-trading/secondary-pricing-section.component.html'),
    bindings: {
        proposal: '<',
        price: '<?',
        noTitle: '<?'
    }
});
